
import Vue, { watch } from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import font1 from '@/assets/font/iconfont.json';
import font2 from '@/assets/font2/iconfont.json';
import font3 from '@/assets/font3/iconfont.json';
import font4 from '@/assets/font4/iconfont.json';
import font5 from '@/assets/font5/iconfont.json';

@Component
export default class ProductDocIcon extends Vue {
  @Prop() confirmSelectIcon: Function;
  data() {
    return {
      icons: [font1, font2, font3, font4, font5].flatMap(obj => (obj.glyphs || []).map(glyph => (obj.css_prefix_text || '') + glyph.font_class))
    };
  }

  selectIcon(icon: any) {
    if (this.confirmSelectIcon) {
      this.confirmSelectIcon(icon);
    }
  }
}
